import { addProductCertificate, fetchProductCertificates, removeProductCertificate, selectProductCertificateById, selectProductCertificates, selectProductCertificatesErrors, selectProductCertificatesPageInfo, selectProductCertificatesRefetchFlags, selectProductCertificatesStatus, updateProductCertificate, } from 'store/parameters/productCertificatesSlice';
import { addProductContinent, fetchProductContinents, removeProductContinent, selectProductContinentById, selectProductContinents, selectProductContinentsErrors, selectProductContinentsPageInfo, selectProductContinentsRefetchFlags, selectProductContinentsStatus, updateProductContinent, } from 'store/parameters/productContinentsSlice';
import { addProductEvent, fetchProductEvents, removeProductEvent, selectProductEventById, selectProductEvents, selectProductEventsErrors, selectProductEventsPageInfo, selectProductEventsRefetchFlags, selectProductEventsStatus, updateProductEvent, } from 'store/parameters/productEventsSlice';
import { addProductFunction, fetchProductFunctions, removeProductFunction, selectProductFunctionById, selectProductFunctions, selectProductFunctionsErrors, selectProductFunctionsPageInfo, selectProductFunctionsRefetchFlags, selectProductFunctionsStatus, updateProductFunction, } from 'store/parameters/productFunctionsSlice';
import { addProductMainCategory, fetchProductMainCategories, removeProductMainCategory, selectProductMainCategories, selectProductMainCategoriesErrors, selectProductMainCategoriesPageInfo, selectProductMainCategoriesRefetchFlags, selectProductMainCategoriesStatus, selectProductMainCategoryById, updateProductMainCategory, } from 'store/parameters/productMainCategoriesSlice';
import { addProductSustainability, fetchProductSustainability, removeProductSustainability, selectProductSustainability, selectProductSustainabilityById, selectProductSustainabilityErrors, selectProductSustainabilityPageInfo, selectProductSustainabilityRefetchFlags, selectProductSustainabilityStatus, updateProductSustainability, } from 'store/parameters/productSustainabilitySlice';
const productParameterConfigs = {
    functions: {
        mode: 'functions',
        labelKey: 'functions',
        addLabelKey: 'add_function',
        editLabelKey: 'edit_function',
        creatorModalName: 'productFunctionCreator',
        editorModalName: 'productFunctionEditor',
        fetchItems: fetchProductFunctions,
        addItem: addProductFunction,
        updateItem: updateProductFunction,
        removeItem: removeProductFunction,
        selectItems: selectProductFunctions,
        selectItemById: selectProductFunctionById,
        selectPageInfo: selectProductFunctionsPageInfo,
        selectStatus: selectProductFunctionsStatus,
        selectErrors: selectProductFunctionsErrors,
        selectRefetchFlags: selectProductFunctionsRefetchFlags,
    },
    sustainability: {
        mode: 'sustainability',
        labelKey: 'sustainability',
        addLabelKey: 'add_sustainability',
        editLabelKey: 'edit_sustainability',
        creatorModalName: 'productSustainabilityCreator',
        editorModalName: 'productSustainabilityEditor',
        fetchItems: fetchProductSustainability,
        addItem: addProductSustainability,
        updateItem: updateProductSustainability,
        removeItem: removeProductSustainability,
        selectItems: selectProductSustainability,
        selectItemById: selectProductSustainabilityById,
        selectPageInfo: selectProductSustainabilityPageInfo,
        selectStatus: selectProductSustainabilityStatus,
        selectErrors: selectProductSustainabilityErrors,
        selectRefetchFlags: selectProductSustainabilityRefetchFlags,
    },
    certificates: {
        mode: 'certificates',
        labelKey: 'certificates',
        addLabelKey: 'add_certificate',
        editLabelKey: 'edit_certificate',
        creatorModalName: 'productCertificateCreator',
        editorModalName: 'productCertificateEditor',
        fetchItems: fetchProductCertificates,
        addItem: addProductCertificate,
        updateItem: updateProductCertificate,
        removeItem: removeProductCertificate,
        selectItems: selectProductCertificates,
        selectItemById: selectProductCertificateById,
        selectPageInfo: selectProductCertificatesPageInfo,
        selectStatus: selectProductCertificatesStatus,
        selectErrors: selectProductCertificatesErrors,
        selectRefetchFlags: selectProductCertificatesRefetchFlags,
    },
    continents: {
        mode: 'continents',
        labelKey: 'continents',
        addLabelKey: 'add_continent',
        editLabelKey: 'edit_continent',
        creatorModalName: 'productContinentCreator',
        editorModalName: 'productContinentEditor',
        fetchItems: fetchProductContinents,
        addItem: addProductContinent,
        updateItem: updateProductContinent,
        removeItem: removeProductContinent,
        selectItems: selectProductContinents,
        selectItemById: selectProductContinentById,
        selectPageInfo: selectProductContinentsPageInfo,
        selectStatus: selectProductContinentsStatus,
        selectErrors: selectProductContinentsErrors,
        selectRefetchFlags: selectProductContinentsRefetchFlags,
    },
    events: {
        mode: 'events',
        labelKey: 'events',
        addLabelKey: 'add_event',
        editLabelKey: 'edit_event',
        creatorModalName: 'productEventCreator',
        editorModalName: 'productEventEditor',
        fetchItems: fetchProductEvents,
        addItem: addProductEvent,
        updateItem: updateProductEvent,
        removeItem: removeProductEvent,
        selectItems: selectProductEvents,
        selectItemById: selectProductEventById,
        selectPageInfo: selectProductEventsPageInfo,
        selectStatus: selectProductEventsStatus,
        selectErrors: selectProductEventsErrors,
        selectRefetchFlags: selectProductEventsRefetchFlags,
    },
    mainCategories: {
        mode: 'mainCategories',
        labelKey: 'main_categories',
        addLabelKey: 'add_main_category',
        editLabelKey: 'edit_main_category',
        creatorModalName: 'productMainCategoryCreator',
        editorModalName: 'productMainCategoryEditor',
        fetchItems: fetchProductMainCategories,
        addItem: addProductMainCategory,
        updateItem: updateProductMainCategory,
        removeItem: removeProductMainCategory,
        selectItems: selectProductMainCategories,
        selectItemById: selectProductMainCategoryById,
        selectPageInfo: selectProductMainCategoriesPageInfo,
        selectStatus: selectProductMainCategoriesStatus,
        selectErrors: selectProductMainCategoriesErrors,
        selectRefetchFlags: selectProductMainCategoriesRefetchFlags,
    },
};
export default productParameterConfigs;
